import React, { useState, useEffect } from 'react';
import { eventPollRatingAnswers } from '../../../../../api/player';
import { useEventContext } from '../../../context/EventContext';
import { useLocaleContext } from '../../../context/LocaleContext';
import UIButton from '../../../../../globalComponents/UIComponents/UIButton';
import Icons from '../../Icons';

export const PollRatingAnswer = ({ answer, value, onChange }) => {
    const { getProperty } = useLocaleContext();
    const [hoverIndex, setHoverIndex] = useState(null);

    const answerText = getProperty(answer, 'text');

    return (
        <div className={'poll-answer'}>
            {!!answerText?.trim() && <div className={'poll-answer-text'}>{getProperty(answer, 'text')}</div>}
            <div className={'poll-answer-rating'}>
                {Array.from({ length: answer.ratingMax || 0 }).map((_, idx) => {
                    const _value = idx + 1;
                    const isActive = (value > 0 && _value <= value) || (hoverIndex !== null && hoverIndex >= idx);
                    return <span
                        key={idx}
                        // onMouseEnter={() => setHoverIndex(idx)}
                        // onMouseLeave={() => setHoverIndex(null)}
                        onClick={() => onChange(_value)}
                        className={'poll-rating-item input-item' + (isActive ? ' active' : '')}
                    >
                        <Icons name="rating_star" />
                    </span>
                })}
            </div>
        </div>
    );
};

export default ({ poll, preview, onAnswer, authorizationCheck }) => {
    const { getProperty, get: getLocale } = useLocaleContext();
    const { event } = useEventContext();
    const [answers, setAnswers] = useState({});

    useEffect(() => {
        setAnswers({});
    }, [poll.id])

    const handleChangeAnswer = (answer, value) => {
        setAnswers(answers => ({...answers, [answer.id]: value }));
    };

    const handleSubmit = async () => {
        if (preview) return;
        const isAuth = await authorizationCheck(poll);
        if (isAuth) {
            await eventPollRatingAnswers(event.eventKey, poll.id, { answers });
            await onAnswer(poll, answers);
        }
    };

    const isComplete = Array.isArray(poll?.answer) && poll.answer.reduce((complete, answer) => (answers[answer.id] > 0 ? complete : false), true);

    return (
        <article className={'poll poll-rating'}>
            {poll.imageUrl && (
                <div className="poll-image-container">
                    <img
                        src={poll.imageUrl}
                        className="poll-image"
                        alt={getProperty(poll, "text")}
                        title={getProperty(poll, "text")}
                    />
                </div>
            )}
            <p className={"poll-text"}>{getProperty(poll, 'text')}</p>
            {poll.object && <p className={'poll-object'}>{poll.object}</p>}
            {Array.isArray(poll?.answer) && poll.answer.map((answer) => (
                <PollRatingAnswer
                    key={answer.id}
                    answer={answer}
                    value={answers[answer.id]}
                    onChange={(value) => handleChangeAnswer(answer, value)}
                />
            ))}
            <p>
                <UIButton color="primary" onClick={handleSubmit} disabled={!isComplete}>
                    {getLocale('polls.answer')}
                </UIButton>
            </p>
        </article>
    );
};
